import {Outlet, createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../messages/routes.messages";

export const Route = createFileRoute("/_app/engineering/suppliers")({
  component: () => <Outlet />,
  staticData: {
    meta: {
      labelDescriptor: routeMessages.suppliers,
      moduleDescriptor: routeMessages.engineering,
      nav: {order: 3, visible: true},
    },
  },
});
